// import React from 'react'
import styled from 'react-emotion'
import Text from '../../../../common/components/Text'

const UserHeader = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: 80,
  marginBottom: 80,
  [Text]: {
    fontSize: 28,
    lineHeight: 1,
    marginTop: 20
  }
})

export default UserHeader
